import { render, staticRenderFns } from "./DistributeCourse.vue?vue&type=template&id=6577d282&scoped=true&"
import script from "./DistributeCourse.vue?vue&type=script&lang=js&"
export * from "./DistributeCourse.vue?vue&type=script&lang=js&"
import style0 from "./DistributeCourse.vue?vue&type=style&index=0&id=6577d282&prod&scoped=true&lang=css&"
import style1 from "./DistributeCourse.vue?vue&type=style&index=1&id=6577d282&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577d282",
  null
  
)

export default component.exports